module.exports = __webpack_public_path__ + "media/images/icons/icons_large/70_lockforKeys-d19cc8c0e6b136d375d9e1455a07a3f0.png";